const PREVIOUS_COUNT_RE = /\(\d+\)\s+/;

export function browserNotifications() {
  function setTitle(count) {
    const title = document.querySelector('title');
    const text = title.textContent.replace(PREVIOUS_COUNT_RE, '');

    if (count === 0) {
      title.textContent = text;
    } else {
      title.textContent = `(${count}) ${text}`;
    }
  }

  function setFavicon(count) {
    const link = document.querySelector('.js-favicon');

    if (count === 0) {
      link?.setAttribute('href', '/static/favicon/favicon-32x32.png');
    } else {
      link?.setAttribute(
        'href',
        '/static/favicon/favicon-notification-32x32.png'
      );
    }
  }

  return {
    setCount(count) {
      setTitle(count);
      setFavicon(count);
    },
  };
}
